import {EValidationTestType} from "../../../utils/validationConfigs";

export const formConfig = {
    login: {
        smsCode: {
            model: "login",
            name: "smsCode",
            standardMessage: undefined,
            validationTests: [
                EValidationTestType.hasValue,
                EValidationTestType.isNumber,
                EValidationTestType.isPin
            ],
            visible: true,
            showSuccess: true,
        },
    },
};
